import { BulkUpdateMethod } from '../../../models/bulk-update.model'
import { Field } from '../../../models/field.model'
import {
  FilterCollection,
  FilterOperator,
  FilterType,
} from '../../../models/filter.model'
import { OrderField } from '../models/order-search.model'
import { OrderViewType } from '../models/order.types'
import { ORDER_STATUSES } from './order-statuses.const'

export const ORDER_FIELDS: Field<OrderField, OrderViewType>[] = [
  {
    label: 'Numero ordine',
    field: 'header.orderNumber',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,

      FilterOperator.between,
      FilterOperator.lessThan,
      FilterOperator.lessOrEqualThan,
      FilterOperator.moreThan,
      FilterOperator.moreOrEqualThan,
    ],
    filterType: FilterType.number,
  },
  {
    label: 'Data ordine',
    field: 'header.date',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,

      FilterOperator.between,
      FilterOperator.beforeThan,
      FilterOperator.beforeOrEqualThan,
      FilterOperator.afterThan,
      FilterOperator.afterOrEqualThan,
    ],
    filterType: FilterType.date,
  },
  {
    label: 'Magazzino assegnato',
    field: 'assignedWarehouseId',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.warehouses,
  },
  {
    label: 'Riferimento data ordine',
    field: 'header.rifDate',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    filterOperators: [
      FilterOperator.equal,

      FilterOperator.between,
      FilterOperator.beforeThan,
      FilterOperator.beforeOrEqualThan,
      FilterOperator.afterThan,
      FilterOperator.afterOrEqualThan,
    ],
    filterType: FilterType.date,
  },
  {
    label: 'Riferimento numero ordine',
    field: 'header.rifOrder',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.text,
  },
  {
    label: 'Riferimento esterno ordine',
    field: 'header.externalRifOrder',
  },
  {
    label: 'Tipologia fattura',
    field: 'header.invoiceType',
  },
  {
    label: 'Processato da',
    field: 'processedBy',
  },
  {
    label: 'Imballato da',
    field: 'packedBy',
  },
  {
    label: 'Tag',
    field: 'tags',
  },
  {
    label: 'Destinatario fatturazione',
    field: 'header.billingAddress.name',
    defaultViews: ['ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Indirizzo fatturazione',
    field: 'header.billingAddress.address1',
  },
  {
    label: 'Indirizzo 2 fatturazione',
    field: 'header.billingAddress.address2',
  },
  {
    label: 'Città fatturazione',
    field: 'header.billingAddress.city',
  },
  {
    label: 'Provincia fatturazione',
    field: 'header.billingAddress.province',
  },
  {
    label: 'Cap fatturazione',
    field: 'header.billingAddress.postalCode',
  },
  {
    label: 'Stato fatturazione',
    field: 'header.billingAddress.countryCode',
  },
  {
    label: 'Telefono fatturazione',
    field: 'header.billingAddress.phone',
  },
  {
    label: 'Email fatturazione',
    field: 'header.billingAddress.email',
  },
  {
    label: 'Canale di vendita',
    field: 'header.channel',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.channels,
  },
  {
    label: 'Tipologia trasporto',
    field: 'header.transport',
  },
  {
    label: 'Corriere',
    field: 'carrierId',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    bulkField: 'CARRIER',
    bulkMethods: [BulkUpdateMethod.set, BulkUpdateMethod.unset],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.carriers,
  },
  {
    label: 'Destinatario destinazione',
    field: 'header.shippingAddress.name',
    defaultViews: ['ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Indirizzo destinazione',
    field: 'header.shippingAddress.address1',
  },
  {
    label: 'Indirizzo 2 destinazione',
    field: 'header.shippingAddress.address2',
  },
  {
    label: 'Città destinazione',
    field: 'header.shippingAddress.city',
  },
  {
    label: 'Provincia destinazione',
    field: 'header.shippingAddress.province',
  },
  {
    label: 'Cap destinazione',
    field: 'header.shippingAddress.postalCode',
  },
  {
    label: 'Stato destinazione',
    field: 'header.shippingAddress.countryCode',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.countries,
  },
  {
    label: 'Telefono destinazione',
    field: 'header.shippingAddress.phone',
  },
  {
    label: 'Email destinazione',
    field: 'header.shippingAddress.email',
  },
  {
    label: 'Tipologia pagamento',
    field: 'header.paymentType',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.payments,
  },
  {
    label: 'Valuta',
    field: 'header.currency',
  },
  {
    label: 'Fattura richiesta',
    field: 'header.requestInvoice',
  },
  {
    label: 'Pagato',
    field: 'header.paid',
  },
  {
    label: 'Importo contrassegno',
    field: 'header.cashOnDelivery.amount',
  },
  {
    label: 'Spedizione i.e.',
    field: 'header.shippingCost',
  },
  {
    label: 'Spedizione i.c.',
    field: 'header.shippingCostWithTaxes',
  },
  {
    label: 'IVA Spedizione',
    field: 'header.shippingTaxes',
  },
  {
    label: 'Subtotale i.e.',
    field: 'header.subTotal',
  },
  {
    label: 'Subtotale i.c.',
    field: 'header.subTotalWithTaxes',
  },
  {
    label: 'Tasse',
    field: 'header.bodyTaxes',
  },
  {
    label: 'Totale',
    field: 'header.totalOrderAmount',
    defaultViews: ['ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Data spedizione',
    field: 'header.shippingDate',
  },
  {
    label: 'Data imballo',
    field: 'packingDate',
  },
  {
    label: 'Numero colli',
    field: 'packagesCount',
  },
  {
    label: 'Numero righe',
    field: 'rowsCount',
  },
  {
    label: 'Numero pezzi',
    field: 'productsCount',
  },
  {
    label: 'Vol. colli (mc)',
    field: 'totalVolume',
  },
  {
    label: 'Peso colli (kg)',
    field: 'totalWeight',
  },
  {
    label: 'Stato',
    field: 'status',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterOptions: ORDER_STATUSES.map((s) => ({
      value: s.code,
      label: s.name,
    })),
    defaultViews: ['ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Note packing',
    field: 'header.packingNotes',
  },
  {
    label: 'Note corriere',
    field: 'header.carrierNotes',
  },
  {
    label: 'Note ordine',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    field: 'header.notes',
  },
  {
    label: 'Diviso',
    field: 'splitted',
  },
  {
    label: 'Duplicato',
    field: 'duplicated',
  },
  {
    label: 'Reso',
    field: 'returned',
    defaultViews: ['ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Volume stimato (mc)',
    field: 'estimatedVolume',
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.lessThan,
      FilterOperator.lessOrEqualThan,
      FilterOperator.moreThan,
      FilterOperator.moreOrEqualThan,
    ],
    filterType: FilterType.number,
  },
  {
    label: 'Peso stimato (kg)',
    field: 'estimatedWeight',
    filterOperators: [
      FilterOperator.equal,
      FilterOperator.lessThan,
      FilterOperator.lessOrEqualThan,
      FilterOperator.moreThan,
      FilterOperator.moreOrEqualThan,
    ],
    filterType: FilterType.number,
  },
  {
    label: 'Alert ordine',
    field: 'header.importantNote',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.boolean,
  },
  {
    label: 'Picking list',
    field: 'pickingListId:ex',
    defaultViews: ['ORDERS_LISTING_MAIN'],
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.boolean,
  },
  {
    label: 'Regalo',
    field: 'header.gift.isEnabled',
  },
  {
    label: 'Destinazione CEE',
    field: 'cee',
  },
  {
    label: 'Allegati',
    field: 'attachments',
    defaultViews: ['ORDERS_LISTING_MAIN'],
  },
  {
    label: 'Causale',
    field: 'header.reasonId',
    filterOperators: [FilterOperator.equal],
    filterType: FilterType.simpleSelect,
    filterCollection: FilterCollection.reasons,
  },
  {
    label: 'Numero tracking',
    field: 'shipments.tracking',
  },
]
